export const creditCardCreditLimitChangeExternal = {
    targetClientId: 'C02345N6',
};
